import mimetypes from 'mime-types';

export function getFileExtension(mimeType?: string) {
  if (!mimeType) return 'unknown';

  const fileExtension = mimetypes.extension(mimeType);
  if (!fileExtension) return 'unknown';

  return fileExtension;
}
